module.exports = "/static-assets/_next/static/images/quiz-party-logo-0b905e54d35aff083009064fe5503015.svg";